<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21.996" viewBox="0 0 20 21.996">
    <g transform="translate(-374 -495)">
      <path class="a" d="M18,8A6,6,0,0,0,6,8c0,7-3,9-3,9H21s-3-2-3-9" transform="translate(372 494)"/>
      <path class="a" d="M13.73,21a2,2,0,0,1-3.46,0" transform="translate(372 494)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'NotoficationIcon'
}
</script>

<style scoped>
svg .a {
  fill: none;
  stroke: #FFFFFF;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
